import React from "react";

import { Trans, withTranslation } from "react-i18next";

import { Callout } from "@blueprintjs/core";

import ServerTable from "./Servers";
import ParkTable from "./Parks";
import DeviceTable from "./Devices";

function ParkingStructure() {
  return (
    <Callout title={<Trans>parking structure</Trans>} icon="th">
      <ServerTable />
      <br />
      <ParkTable />
      <br />
      <DeviceTable />
    </Callout>
  );
}

export default withTranslation()(ParkingStructure);
